import Vue from "vue";
import firebase from "firebase/compat/app";
import VueRouter from "vue-router";
// import store from '@/store/store.js';
//views:
import Login from "@/views/Login.vue";
// import C from "@/constants"

Vue.use(VueRouter);

const routes = [
  {
    name: "Login",
    path: "/login",
    component: Login,
  },
  {
    name: "Register",
    path: "/register",
    component: () => import("@/views/Register.vue"),
  },
  {
    // name: "Main",
    path: "/",
    component: () => import("@/views/Layout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "MainMenu",
        path: "/dashboard",
        component: () => import("@/components/MainMenu"),
      },
      {
        name: "MustSee",
        path: "must-see",
        component: () => import("@/components/MustSee"),
      },
      {
        name: "Weather",
        path: "weather",
        component: () => import("@/components/Weather"),
      },
    ],
  },

  {
    // name: "Main",
    path: "/library",
    component: () => import("@/views/Layout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "Library",
        path: "",
        component: () => import("@/components/Library"),
      },
      {
        name: "LibraryList",
        path: "/library-list/:id?",
        component: () => import("@/components/LibraryList"),
      },
      {
        name: "LibraryItemsList",
        path: "/library-items/:id?",
        component: () => import("@/components/LibraryItemsList"),
      },
      {
        name: "LibraryList",
        path: "/library-list/:id?",
        component: () => import("@/components/LibraryList"),
      },
      {
        name: "LibraryItemsList",
        path: "/library-items/:id?",
        component: () => import("@/components/LibraryItemsList"),
      },
      {
        name: "LibraryCategory",
        path: "/library/:id?",
        component: () => import("@/components/Library"),
      },
      {
        name: "LibraryCard",
        path: "/library-item/:id?",
        component: () => import("@/components/LibraryCard"),
      },
      {
        name: "TestGallery",
        path: "/swiper",
        component: () => import("@/components/TestGallery"),
      },
      {
        name: "MyMarkers",
        path: "/my-markers",
        component: () => import("@/components/MyMarkers"),
      },
      {
        name: 'Itinerary',
        path: '/itinerary',
        component: () => import('@/components/Itinerary'),
        meta: {
          title: 'Itineraries | Parks App',
        },
      },
      {
        name: 'ItineraryDetail',
        path: '/itinerary/:id',
        component: () => import('@/components/ItineraryDetail'),
        meta: {
          title: 'Itinerary Details | Parks App',
        },
      },
      {
        name: 'WwfDashboard',
        path: '/wwf',
        component: () => import('@/components/wwf/WwfDashboard'),
        meta: {
          title: "WWF Donations | Support Wildlife Conservation | Parks App",
        },
      },
      {
        name: "Memories",
        path: "/memories",
        component: () => import("@/components/Memories"),
        meta: {
          title: "Memories | Parks App",
        },
      },
      {
        name: "Memories2",
        path: "/memories2",
        component: () => import("@/components/Memories2"),
        meta: {
          title: "Memories | Parks App",
        },
      },
    ],
  },
  {
    // name: "Main",
    path: "/map",
    component: () => import("@/views/Layout.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: "Map",
        path: "",
        component: () => import("@/components/map/Map.vue"),
      },
      {
        name: "Map2",
        path: "map2",
        component: () => import("@/components/map/MapOld.vue"),
      },
    ],
  },
  {
    // name: "Admin",
    path: "/admin",
    component: () => import("@/views/LayoutAdmin.vue"),
    meta: {
      requiresAuth: true,
    },

    children: [
      {
        name: "DashboardAdmin",
        path: "",
        component: () => import("@/components/admin/DashboardAdmin"),
      },
      {
        name: "CreateAnimal",
        path: "animals/create/:id?",
        component: () => import("@/components/admin/AnimalCreate"),
      },
      {
        name: "EditAnimal",
        path: "animals/edit/:id?",
        component: () => import("@/components/admin/AnimalCreate"),
      },
      {
        name: "UploadPhotos",
        path: "animals/upload/:id?",
        component: () => import("@/components/admin/UploadPhotosList"),
      },
      {
        name: "AnimalCard",
        path: "animal/:id?",
        component: () => import("@/components/admin/AnimalCard"),
      },
      {
        name: "AnimalsList",
        path: "animals",
        component: () => import("@/components/admin/ItemsList/ItemsList.vue"),
      },
      {
        name: "CreatePlace",
        path: "places/create",
        component: () => import("@/components/admin/PlaceCreate"),
      },
      {
        name: "EditPlace",
        path: "places/edit/:id?",
        component: () => import("@/components/admin/PlaceCreate"),
      },
      {
        name: "PlacesList",
        path: "places",
        component: () => import("@/components/admin/ItemsList/ItemsList.vue"),
      },
      {
        name: "CreatePlant",
        path: "plants/create",
        component: () => import("@/components/admin/PlantCreate"),
      },
      {
        name: "EditPlant",
        path: "plants/edit/:id?",
        component: () => import("@/components/admin/PlantCreate"),
      },
      {
        name: "PlantsList",
        path: "plants",
        // component: () => import('@/components/admin/PlantsList.vue'),
        component: () => import("@/components/admin/ItemsList/ItemsList.vue"),
      },
      {
        name: "CreatePeople",
        path: "people/create",
        component: () => import("@/components/admin/PeopleCreate"),
      },
      {
        name: "EditPeople",
        path: "people/edit/:id?",
        component: () => import("@/components/admin/PeopleCreate"),
      },
      {
        name: "PeopleList",
        path: "people",
        component: () => import("@/components/admin/ItemsList/ItemsList"),
      },
      {
        name: "CreateLocation",
        path: "locations/create",
        component: () => import("@/components/admin/LocationCreate"),
      },
      {
        name: "EditLocation",
        path: "locations/edit/:id?",
        component: () => import("@/components/admin/LocationCreate"),
      },
      {
        name: "LocationsList",
        path: "locations",
        component: () => import("@/components/admin/ItemsList/ItemsList"),
      },
      {
        name: "LibraryItemCreate",
        path: "li/create/:id?",
        component: () => import("@/components/admin/LibraryItemCreate"),
      },
      {
        name: "LibraryItemsList",
        path: "lis",
        component: () => import("@/components/admin/LibraryItemsList"),
      },
      {
        name: "LibraryItemCreateSelection",
        path: "library/create",
        component: () => import("@/components/admin/LibraryItemCreateSelection"),
      },
      {
        name: "CreateCategory",
        path: "categories/create",
        component: () => import("@/components/admin/CategoryCreate"),
      },
      {
        name: "EditCategory",
        path: "categories/edit/:id?",
        component: () => import("@/components/admin/CategoryCreate"),
      },
      {
        name: "CategoryCard",
        path: "category/:id?",
        component: () => import("@/components/admin/CategoryCard"),
      },
      {
        name: "CategoriesList",
        path: "categories/:id?/:folder?",
        component: () => import("@/components/admin/ItemsList/ItemsList.vue"),
      },
      {
        name: "ClassIcons",
        path: "classIcons",
        component: () => import("@/components/admin/LibraryClassIcons/LibraryClassIcons.vue"),
      },
      {
        name: "MarkersList",
        path: "markers",
        component: () => import("@/components/admin/MarkersList"),
      },
      {
        name: "MarkersHistoryList",
        path: "markers/history",
        component: () => import("@/components/admin/MarkersHistory/MarkersHistoryList.vue"),
      },
      {
        name: "Alerts",
        path: "markers/alerts",
        component: () => import("@/components/admin/MarkersList.vue"),
        props: { isAlerts: true },
      },
      {
        name: 'CreateItineraries',
        path: 'itinerary/create',
        component: () => import('@/components/admin/CreateItinerary.vue'),
        props: { isAlerts: true },
      },
      {
        name: 'Documents',
        path: 'documents',
        component: () => import('@/components/admin/ItemsList/ItemsList.vue'),
      },
      {
        name: 'CreateDocument',
        path: 'documents/create',
        component: () => import('@/components/admin/UploadPDF/UploadPDF.vue'),
      },
      {
        name: 'EditDocument',
        path: 'documents/edit/:id?',
        component: () => import('@/components/admin/UploadPDF/UploadPDF.vue'),
      },
      // {
      //   name: "ProfileAdmin",
      //   path: "profile",
      //   component: () => import("@/components/Profile.vue")
      // },
      {
        name: "UsersList",
        path: "users",
        component: () => import("@/components/admin/UsersList"),
      },
      {
        name: "CreateUser",
        path: "create-user",
        component: () => import("@/components/admin/UserCreate"),
      },
      {
        name: "UserAccount",
        path: "user/:id?",
        component: () => import("@/components/admin/UserAccount"),
      },
      // {
      //   name: "Password",
      //   path: "password",
      //   component: () => import("@/components/user/Security")
      // },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// make sure only logged-in users have access to the content while onyl guests(+not signed-in users) see register & login
router.beforeEach((to, from, next) => {
  console.log("NEXT: ");
  console.log(to);
  console.log("FROM: ");
  console.log(from);

  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (to.fullPath === "/") {
    next("/dashboard");
    return;
  }
  // redirect to login if not signed in
  if (requiresAuth && !currentUser) next("/login");
  // skip login if user is already signed in
  else if (!requiresAuth && currentUser) next("/dashboard");
  // continue navigation otherwise
  else next();
});

export default router;
